export const formatCurrency = (
  amount,
  FractionDigits = 0
) => {
  const amountNumber =
    typeof amount === 'number' ? amount : parseFloat(amount ?? '')
  if (isNaN(amountNumber)) {
    return amount
  }
  // Format the number with commas and dollar sign without decimal places
  const formattedNumber = amountNumber.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: FractionDigits,
    maximumFractionDigits: FractionDigits,
  })

  return formattedNumber
}